<template>
  <v-layout justify-center>
    <v-col
      xs="8"
      sm="8"
      md="8"
      lg="7"
      xl="7">
      <v-card class="mb-5" id="card">
        <!--タイトルバー-->
        <v-app-bar
          app
          absolute
          color="grey darken-1"
          dark
          fixed
        >
          <v-toolbar-title>
            <!--アイコン-->
            <v-icon>
              {{ icon }}
            </v-icon>
            <!--タイトル-->
            {{ title }}
          </v-toolbar-title>
        </v-app-bar>
        <!--お問い合わせ先-->
        <v-content>
          <v-layout>
            <v-sheet
            class="overflow-y-auto">
            <!--リストの中身を繰り返す-->
            <v-list :width="listWidth">
              <div
              v-for="(item, i) in lists"
              :key="i">
                <v-list-item class="my-2">
                  <!--アイコン-->
                  <v-list-item-icon>
                    <v-icon color="indigo">
                      {{ item.icon }}
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <!--サブタイトル-->
                    <v-list-item-subtitle>
                      {{ item.subtitle }}
                    </v-list-item-subtitle>
                    <!--タイトル-->
                    <v-list-item-title>
                      {{ item.title }}
                      <a href="tel:0886258102">{{ item.title1 }}</a>
                      <a href="mailto:info@konniesystem.co.jp">{{ item.title2 }}</a>
                      <a href="https://www.facebook.com/konniesystem/">{{ item.title3 }}</a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!--仕切り線-->
                <v-divider :v-if="item.hasDivider" inset></v-divider>
              </div>
            </v-list>
            </v-sheet>
          </v-layout>
        </v-content>
      </v-card>
    </v-col>
  </v-layout>
</template>

<style>
.v-list-item__title {
  white-space: normal !important;
}
.v-list-item__subtitle {
  white-space: normal !important;
}
main.v-content {
  padding-top: 60px !important;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトルバーのアイコン
      icon: 'mdi-phone',
      // タイトル
      title: 'お問い合わせ',
      // 以下内容のリスト
      lists: [
        {
          icon: 'mdi-map-marker',
          subtitle: '住所',
          title: `〒770-0936
          徳島県徳島市中央通3丁目１番地`,
          hasDivider: 'true'
        },
        {
          icon: 'mdi-phone',
          subtitle: '電話番号',
          title1: '088-625-8102',
          hasDivider: 'true'
        },
        {
          icon: 'mdi-printer',
          subtitle: 'FAX番号',
          title: '088-625-8104',
          hasDivider: 'true'
        },
        {
          icon: 'mdi-email',
          subtitle: 'E-MAIL',
          title2: 'info@konniesystem.co.jp',
          hasDivider: 'false'
        },
        {
          icon: 'mdi-facebook',
          subtitle: 'FaceBook',
          title3: 'https://www.facebook.com/konniesystem/',
          hasDivider: 'true'
        }
      ],
      // リサイズイベント用 初期値0
      listWidth: 0
    }
  },
  methods: {
  },
  created () {
    window.addEventListener('resize', this.changeListWidth)
  },
  // DOM作成の際に画面幅特定イベントを登録
  mounted () {
    const cardWidth = document.getElementById('card').clientWidth
    this.listWidth = cardWidth
  }
}
</script>
